module.exports = __webpack_public_path__ + "static/media/administrativo.49928ad4.png";